import { render, staticRenderFns } from "./FactoryAddressHistory.vue?vue&type=template&id=1a291c72&scoped=true"
import script from "./FactoryAddressHistory.vue?vue&type=script&lang=ts"
export * from "./FactoryAddressHistory.vue?vue&type=script&lang=ts"
import style0 from "./FactoryAddressHistory.vue?vue&type=style&index=0&id=1a291c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a291c72",
  null
  
)

export default component.exports